<template>
  <div>
    <div class="chat-item chat-item--question">
      <writing-animation v-if="show.writing_1"></writing-animation>
      <transition name="fade">
        <div class="chat-item__inr" v-if="show.question">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              <span class="txt-or">それでは最後に</span>、本サービスをご利用する際の<span class="question__txt">パスワード</span>を決めてください！
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div
      class="chat-item chat-item--anser chat-item--input"
      :class="displayUserIconClass($parent.formData.sex)"
      :data-name="displayIconName($parent.formData.name_sei)"
      v-if="show.answer"
    >
      <transition name="fade">
        <div class="chat-item__inr" v-if="show.answer">
          <div class="input--col1 password-col">
            <div class="password-col">
              <input :type="setType" v-model="password" placeholder="パスワード">
              <span class="input--password" :class="setIconClass" @click="toggleSetPasswordType"></span>
            </div>
            <small>※{{ $parent.formData.name_sei }}さんの覚えやすいパスワードを半角英数字で決めてください</small>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <button
          class="chat-item--anser__button"
          type="button"
          :disabled="isDisabled"
          @click.once="clickFixPassword"
          @click="changePassword"
        >{{ btnContent }}</button>
      </transition>
    </div>
    <transition name="fade">
      <div
        class="chat-item chat-item--anser"
        :class="displayUserIconClass($parent.formData.sex)"
        :data-name="displayIconName($parent.formData.name_sei)"
        v-if="show.fix"
      >
        <div class="chat-item__inr">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              {{ displayVisivilityPassword($parent.formData.password) }}
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="chat-item chat-item--question" v-if="show.writing_2 || show.confirmMessage">
      <writing-animation v-if="show.writing_2"></writing-animation>
      <transition name="fade">
        <div class="chat-item__inr" v-if="show.confirmMessage">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              <span>ありがとうございます！</span><br />
              それでは「<a href="https://www.daini-agent.jp/terms" target="_blank">利用規約</a>」及び「<a href="https://www.neo-career.co.jp/policy/" target="_blank">個人情報の取扱いについて</a>」にご同意の上、「登録する」ボタンを押してください。
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import GenderMixin from '../../mixins/GenderMixin'
import functionsMixin from '../../mixins/functionsMixin'
import WritingAnimation from '../animations/WritingAnimation'

export default {
  name: 'FormPassword',
  mixins: [GenderMixin, functionsMixin],
  components: {
    WritingAnimation
  },
  data: function () {
    return {
      show: {
        writing_1: true,
        question: false,
        answer: false,
        next: false,
        fix: false,
        writing_2: false,
        confirmMessage: false
      },
      isDisabled: true,
      isFix: false,
      btnContent: '次へ',
      password: null,
      viewDot: '',
      setType: 'password',
      setIconClass: 'is-visibility',
      isVisibility: true
    }
  },
  mounted: function () {
    setTimeout(function () {
      this.show.writing_1 = false
      this.show.question = true
      this.autoScroll()
      setTimeout(function () {
        this.show.answer = true
        this.autoScroll()
      }.bind(this), 500)
    }.bind(this), 1000)
  },
  watch: {
    password: function (val) {
      this.viewDot = ''
      this.isDisabled = true
      if (val) {
        let passwordReg = /^[A-Za-z0-9]*$/
        if (passwordReg.test(this.password)) {
          this.show.next = true
          this.autoScroll()
          for (let n = 1; n <= this.password.length; n++) {
            this.viewDot += '●'
          }
        }
        this.isDisabled = false
        if (this.isFix) {
          this.btnContent = '更新'
        } else {
          this.btnContent = '次へ'
        }
      }
    },
    isVisibility: function () {
      if (this.isVisibility) {
        this.setType = 'password'
        this.setIconClass = 'is-visibility'
      } else {
        this.setType = 'text'
        this.setIconClass = 'is-unvisibility'
      }
    }
  },
  methods: {
    toggleSetPasswordType: function () {
      this.isVisibility = !this.isVisibility
    },
    clickFixPassword: function () {
      this.show.answer = false
      this.isFix = true
      this.isDisabled = true
      this.$emit('form-fix-password', this.password)
      // this.show.answer = false
      // this.show.next = false
      this.show.fix = true
      this.autoScroll()
      setTimeout(function () {
        this.show.writing_2 = true
        this.autoScroll()
        setTimeout(function () {
          this.show.writing_2 = false
          this.show.confirmMessage = true
          this.autoScroll()
          this.$emit('form-next')
        }.bind(this), 1000)
      }.bind(this), 500)
    },
    changePassword: function () {
      if (this.isFix) {
        this.$emit('form-change-password', this.password)
        this.isDisabled = true
      }
    }
    // fixPassword: function () {
    //   this.$emit('form-fix-password', this.password)
    // }
  }
}
</script>

<style lang="scss" scoped>
  .fade {
    &-enter-active, &-leave-active {
      will-change: opacity;
      transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }
    &-enter, &-leave-to {
      opacity: 0;
    }
  }
  .fontBlack {
    color: #000;
  }
  .password-col {
    position: relative;
    & .input--password {
      position: absolute;
      top: 50%;
      right: 3%;
      transform: translate(0, -50%);
      width: 24px;
      height: 24px;
      cursor: pointer;
      &.is-visibility {
        background-image: url(../../static/img/visibility.svg);
        background-size: contain;
        background-repeat: no-repeat;
      }
      &.is-unvisibility {
        background-image: url(../../static/img/visibility_off.svg);
        background-size: contain;
        background-repeat: no-repeat;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/forms/FormPassword.vue